export enum EMarketSegment {
  RCR = "RCR",
  CCR = "CCR",
  OCR = "OCR",
}
